export default function About() {
  return (
    <section id="sobre" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://static.readdy.ai/image/e4140a6110134fefa958645e77b5a66a/d5d784006bf82c5a8e826cdcc0936d5e.jpeg"
                alt="Empreendimento Gleimatus"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-8 -right-8 w-64 h-64 bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl -z-10"></div>
          </div>

          {/* Content */}
          <div>
            <div className="inline-block bg-amber-100 text-amber-700 px-4 py-2 rounded-full text-sm font-semibold mb-6 uppercase tracking-wider">
              Sobre Nós
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Excelência em Construção Civil
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              A <strong className="text-gray-900">Gleimatus Empreendimentos Ltda</strong> é uma empresa sediada em Carandaí, Minas Gerais, especializada em incorporação e construção civil com foco em empreendimentos residenciais de alto padrão.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Com mais de 10 anos de experiência no setor, a Gleimatus consolidou sua atuação pela credibilidade, seriedade e excelência técnica, transformando projetos em patrimônios duradouros.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Desde sua fundação, a empresa atua com uma visão empreendedora, sempre buscando o equilíbrio entre viabilidade financeira, qualidade construtiva e valorização imobiliária, garantindo aos seus clientes e investidores resultados sólidos e sustentáveis.
            </p>

            {/* Features */}
            <div className="grid grid-cols-2 gap-4">
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                  <i className="ri-building-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Alto Padrão</div>
                  <div className="text-sm text-gray-600">Empreendimentos exclusivos</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                  <i className="ri-shield-check-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Credibilidade</div>
                  <div className="text-sm text-gray-600">Confiança comprovada</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                  <i className="ri-line-chart-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Valorização</div>
                  <div className="text-sm text-gray-600">Investimento seguro</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-100 rounded-lg flex-shrink-0">
                  <i className="ri-time-line text-amber-600 text-xl"></i>
                </div>
                <div>
                  <div className="font-semibold text-gray-900">Pontualidade</div>
                  <div className="text-sm text-gray-600">Prazos cumpridos</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}